import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  UncontrolledDropdown,
} from "reactstrap";
import styled from "styled-components";

import logo from "../assets/copysmith-logo-26.png";
import { logOutUser } from "../auth/authImplementation";
import { UserContext } from "../auth/UserProvider";
import { colors } from "../components/shared/styles";
import Subtitle from "../components/shared/text/Subtitle";
import { smMedia } from "../utils/getMediaStyle";
import { routes } from "../utils/routes";

import Button from "./Button";

const TopNavbar = styled(Navbar)`
  background: ${colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  height: 112px;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
  ${smMedia`
    height:auto;
  `}
`;
const HeaderLink = styled(RouterNavLink)`
  margin-right: 51px;
  float: left;
  &:hover {
    text-decoration: none;
  }
`;
const BrandLink = styled(NavbarBrand)`
  margin-right: 71px;
  ${smMedia`margin-right:0px`};
`;
const HeaderLogo = styled.img`
  width: 186px;
`;

const NavBarHome = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const logoutWithRedirect = () => logOutUser();
  const makeNavigatorFunction = (path) => () => history.push(path);
  const navigateToLogIn = makeNavigatorFunction("login");
  const navigateToSignUp = makeNavigatorFunction("signup");
  const user = useContext(UserContext);

  return (
    <div className="nav-container">
      <TopNavbar expand="md" light className="pl-md-1 pr-md-1 pl-xl-5 pr-xl-5">
        <div className="container-fluid">
          <BrandLink href="/">
            <HeaderLogo src={logo}></HeaderLogo>
          </BrandLink>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              {routes.map((route) => {
                let linkProps = {
                  ...route,
                };
                if (route.hash) {
                  delete linkProps.activeClassName;
                  linkProps = {
                    ...linkProps,
                    as: "a",
                    href: "/" + route.hash,
                  };
                }
                return (
                  <NavItem key={route.name}>
                    <HeaderLink {...linkProps}>
                      <Subtitle>{route.name}</Subtitle>
                    </HeaderLink>
                  </NavItem>
                );
              })}
            </Nav>
            <Nav navbar>
              {!user && (
                <>
                  <NavItem>
                    <Button
                      id="qsLoginBtn"
                      color="primary"
                      variation="outlined"
                      className="mr-3"
                      onClick={navigateToLogIn}
                    >
                      {" "}
                      Log in
                    </Button>
                  </NavItem>
                  <NavItem>
                    <Button
                      id="qsLoginBtn"
                      color="primary"
                      className="btn-margin"
                      onClick={navigateToSignUp}
                    >
                      Sign Up Free
                    </Button>
                  </NavItem>
                </>
              )}
              {user && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ marginRight: 20 }}>{user.displayName}</div>
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret id="profileDropDown">
                      {/* <img
                      src={user.picture}
                      alt='Profile'
                      className='nav-user-profile rounded-circle'
                      width='50'
                    /> */}
                    </DropdownToggle>

                    <DropdownMenu className="dropdown-menu-right">
                      <DropdownItem
                        tag={RouterNavLink}
                        to="/templates"
                        className="dropdown-profile"
                        activeClassName="router-link-exact-active"
                      >
                        <FontAwesomeIcon icon="user" className="mr-3" />
                        Dashboard
                      </DropdownItem>
                      <DropdownItem
                        id="qsLogoutBtn"
                        onClick={() => logoutWithRedirect()}
                      >
                        <FontAwesomeIcon icon="power-off" className="mr-3" />
                        Log out
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              )}
            </Nav>
            {user && (
              <Nav
                className="d-md-none justify-content-between"
                navbar
                style={{ minHeight: 170 }}
              >
                <NavItem>
                  <span className="user-info">
                    <img
                      src={user.picture}
                      alt="Profile"
                      className="nav-user-profile d-inline-block rounded-circle mr-3"
                      width="50"
                    />
                    <h6 className="d-inline-block">{user.name}</h6>
                  </span>
                </NavItem>
                <NavItem>
                  <FontAwesomeIcon icon="user" className="mr-3" />
                  <RouterNavLink
                    to="/profile"
                    activeClassName="router-link-exact-active"
                  >
                    Profile
                  </RouterNavLink>
                </NavItem>
                <NavItem>
                  <FontAwesomeIcon icon="power-off" className="mr-3" />
                  <RouterNavLink
                    to="#"
                    id="qsLogoutBtn"
                    onClick={() => logoutWithRedirect()}
                  >
                    Log out
                  </RouterNavLink>
                </NavItem>
              </Nav>
            )}
          </Collapse>
        </div>
      </TopNavbar>
    </div>
  );
};

export default NavBarHome;
